<template>
  <div class="edit-view">
    <form @submit.prevent="editUnit">
      <div class="pt-0h mx-0h pb-1">
        <h2 class="pb-0">{{ $t('unit.editUnit.header') }}</h2>
        <p class="pb-0">{{ $t('unit.editUnit.subText') }}</p>
      </div>

      <TextInput
        v-model="serialNumber"
        :label="$t('unit.editUnit.serialNumber')"
        class="unit-serial-number"
        disabled
      >
        <template #append>
          <div style="margin-right: .3rem">
            <BtnComponent danger outline @click.prevent="unpairUnit">{{ $t('unit.editUnit.unpair') }}</BtnComponent>
          </div>
        </template>
      </TextInput>
      <TextInput v-model="name" :label="$t('unit.editUnit.unitName')" class="unit-name" />
      <TextInput v-model="note" :label="$t('unit.editUnit.note')" class="unit-note" />
      <BtnComponent
        button
        type="submit"
        primary
        large
        block
        class="unit-submit mt-2"
      >
        {{ $t('unit.editUnit.save') }}
      </BtnComponent>
    </form>
  </div>
</template>

<script>
import TextInput from '@acs/components-library/src/components/common/Input.vue';
import BtnComponent from '@acs/components-library/src/components/common/Btn.vue';

import {
  ViewQuery,
  UpdateUnitMutation,
  UnpairUnitMutation,
} from '@acs/components-library/src/gql/live/UnitEditModal.js';
import { useToastStore } from '../store/toastStore.js';

export default {
  components: {
    TextInput,
    BtnComponent,
  },
  props: {
    sn: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ['onUnpaired', 'onUpdated', 'onCancel'],
  setup() {
    const toastStore = useToastStore();
    return { toastStore };
  },
  data() {
    return {
      serialNumber: this.sn,
      name: '',
      note: '',
      position: null,
    };
  },
  apollo: {
    unitBySerialNumber: {
      query: ViewQuery,
      variables() {
        return { sn: this.sn };
      },
      skip() {
        return !this.sn;
      },
      update(data) {
        const { unitBySerialNumber } = data;

        if (!unitBySerialNumber) {
          return;
        }

        this.name = unitBySerialNumber.name;
        this.note = unitBySerialNumber.note;
        this.position = unitBySerialNumber.position;
      },
    },
  },
  methods: {
    async editUnit() {
      const { name, note } = this;
      const { data } = await this.$apollo.mutate({
        mutation: UpdateUnitMutation,
        variables: {
          update: {
            serialNumber: this.sn,
            name,
            note,
          },
        },
      });

      const { __typename: typename } = data.updateUnit;

      if (typename === 'UnitNotPairedError') {
        this.toastStore.showError(this.$t('unit.unitNotPaired'));
        return;
      }

      this.toastStore.showSuccess(this.$t('unit.editUnit.updated'));
      this.$emit('onUpdated');
    },
    async unpairUnit() {
      if (!confirm(this.$t('unit.editUnit.unpairConfirmation'))) {
        return;
      }

      const serialNumber = this.sn;
      const { data } = await this.$apollo.mutate({
        mutation: UnpairUnitMutation,
        variables: { serialNumber },
      });

      const { __typename: typename } = data.unpairUnit;

      if (typename === 'UnitNotPairedError') {
        this.toastStore.showError(this.$t('unit.unitNotPaired'));
        return;
      }

      if (typename === 'UnitUnpaired') {
        this.unpaired = true;
        this.$emit('onUnpaired');
      } else {
        this.toastStore.showError(this.$t('unit.editUnit.unpairFailed', { typename: typename } ));
        return;
      }

      this.toastStore.showSuccess(this.$t('unit.editUnit.unpaired'));
    },
  },
};
</script>
<style scoped lang="scss">
.edit-view {
  max-width: 30rem;
  margin: 0 auto;
}
</style>
